import { render, staticRenderFns } from "./MemoryX.vue?vue&type=template&id=2f7964c1&lang=pug&"
import script from "./MemoryX.vue?vue&type=script&lang=js&"
export * from "./MemoryX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports